module.exports = __webpack_public_path__ + "img/1181801.jpg";